<template>
  <div class="tab">
    <h3>调查负责人工作流程示意图</h3>
    <div>
        <img src="../../assets/diagram.png" alt="">
    </div>
  </div>
</template>
<script>
export default {
  name: 'diagram',
  data () {
    return {}
  }
}
</script>
<style scoped src="../../assets/style/grandchild.css">
  /* @import '../assets/style/child.css'; */
</style>



// WEBPACK FOOTER //
// src/components/tabs/diagram.vue